import React from 'react';
import * as actionTypes from "@redux/actionTypes";
import { useDispatch } from "react-redux";
import { SignOutIcon, SettingIcon } from '@util/svgicon.js';
import useSignOut from '@hooks/useSignOut';

const SignOutButton = () => {

    const dispatch = useDispatch();
    const { signOutHandler } = useSignOut();

    const profileModelHandler = () => {
        dispatch({
            type: actionTypes.PROFILE_MODEL,
            payload: true,
        });
    }

    return (
        <div className='absolute -top-[176px] left-[72px] flex w-[400px] flex-col items-start rounded-[8px] border-[1px] border-solid border-[#DEDEDE] [box-shadow:0px_2px_4px_0px_rgba(0,_0,_0,_0.40)]'>
            <div className='w-full flex px-[16px] py-[12px] items-center bg-[#FFF] rounded-t-[8px]'>
                <p className='text-[#727272] text-[13px] not-italic font-medium leading-[15px] tracking-[-0.52px]'>More options</p>
            </div>
            <button className='w-full flex p-[16px] items-center gap-[10px] border-b-[1px] border-solid border-[#F3F3F3] bg-[#FFF]' onClick={profileModelHandler}>
                <div className='flex p-[4px] items-center gap-[10px] rounded-[8px]'>
                    <SettingIcon />
                </div>
                <div className='flex flex-col items-start gap-[4px]'>
                    <p className='text-[#000] text-[16px] not-italic font-semibold leading-[normal] tracking-[-0.64px]'>Settings</p>
                    <p className='text-[#727272] text-[13px] not-italic font-medium leading-[15px] tracking-[-0.52px]'>Go to your profile settings.</p>
                </div>
            </button>
            <button className='w-full flex p-[16px] items-center gap-[10px] bg-[#FFF] rounded-b-[8px]' onClick={signOutHandler}>
                <div className='flex p-[4px] items-center gap-[10px] rounded-[8px]'>
                    <SignOutIcon />
                </div>
                <div className='flex flex-col items-start gap-[4px]'>
                    <p className='text-[#EA0045] text-[16px] not-italic font-semibold leading-[normal] tracking-[-0.64px]'>Sign out</p>
                    <p className='text-[#727272] text-[13px] not-italic font-medium leading-[15px] tracking-[-0.52px]'>Logs you out of the FrodoBots system.</p>
                </div>
            </button>
        </div>
    );
};

export default SignOutButton;
